module.exports = __webpack_public_path__ + "static/media/hero_img_skill_validation.382d3644.png";